export const getAccordionStyles = (isDarkMode: boolean) => {
  return {
    item: {
      border: `.2rem solid ${isDarkMode ? "#f0f0f0" : "#B2B2B2"}`,
      borderRadius: ".5rem",
      marginBottom: "1rem",
      backgroundColor: isDarkMode ? "#292929" : "#f0f0f0",
      transition: "background-color 0.3s ease",
      "&:hover": {
        backgroundColor: isDarkMode ? "#292929" : "#f0f0f0",
      },
    },
    control: {
      padding: ".5rem 1.5rem",
      fontWeight: 600,
      fontSize: "1.2rem",
      color: isDarkMode ? "#f0f0f0" : "#201b41",
      backgroundColor: isDarkMode ? "#292929" : "#f0f0f0",
      "&:hover": {
        backgroundColor: isDarkMode ? "#292929" : "#e0e0e0",
      },
    },
    panel: {
      padding: "12px 16px",
      backgroundColor: isDarkMode ? "#292929" : "#f0f0f0",
      borderRadius: "0 0 .5rem .5rem",
    },
    chevron: {
      color: isDarkMode ? "#f0f0f0" : "#201b41",
    },
    label: {
      color: isDarkMode ? "#f0f0f0" : "#201b41",
    },
  };
};
